export default class ImageUploadError extends Error {
    constructor(message, payload) {
        super(message)
        this.name = 'ImageUploadError'
        this.payload = payload
    }
}
